import { createRouter, createWebHistory } from 'vue-router'
import { usePtsSignUpStore } from '@/store/PtsSignupTest'
import { useMicrositeStore } from '@/store/Microsites'

const PTS = () => /* webpackChunkName: "ms-pts" */ import('@/views/pts/index.vue')

const routes = [
  {
    path: '/maplestory/public-test-server',
    component: PTS,
    beforeEnter: async (to, _from, next) => {
      const PtsSignUpStore = usePtsSignUpStore()
      const micrositeStore = useMicrositeStore()

      // if (PtsSignUpStore.isLoggedIn === null) {
      //   try {
      //     // await PtsSignUpStore.checkUserStatus()
      //   } catch {
      //     // Intentionally ignore errors when checking user access
      //   }
      // }

      try {
        micrositeStore.loading = true

        await PtsSignUpStore.fetchNewsList()

        // if (to.query.ptssignup) {
        //   // Remove the query parameter
        //   const query = { ...to.query }
        //   delete query.ptssignup

        //   if (PtsSignUpStore.isLoggedIn === null) await PtsSignUpStore.checkUserStatus(true)

        //   micrositeStore.loading = false

        //   next({
        //     ...to,
        //     query: query,
        //     replace: true,
        //   })

        //   return
        // } else {
        //   if (PtsSignUpStore.isLoggedIn === null) await PtsSignUpStore.checkUserStatus(false)
        //   micrositeStore.loading = false
        // }
      } catch {
        // Intentionally ignore errors when processing query parameters
      }

      micrositeStore.loading = false
      next()
    },
  },
  {
    name: 'news-detail',
    path: '/maplestory/public-test-server/news/:newsCategory?/:newsId(\\d+)/:seo?',
    component: () => /* webpackChunkName: "ms-pts" */ import('@/views/pts/NewsDetail.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    beforeEnter: (to) => {
      window.location.href = '/maplestory/error'
    },
    component: { template: '<div></div>' },
  },
]

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

export { router, routes }
